export default function defaultDates() {
  const today = new Date();
  const lastWeek = new Date();
  lastWeek.setDate(lastWeek.getDate() - 7);
  const toDefaultDate = today.toISOString().slice(0, 10);
  const fromDefaultDate = lastWeek.toISOString().slice(0, 10);

  return [fromDefaultDate, toDefaultDate];
}
